// Quote terms: accepted once per company (per wording version) before any quote
// can be sent from the console or offered instantly on a tool. Separate from the
// per-tool estimate terms (terms.ts), which cover the estimate method.
//
// Bump QUOTE_TERMS_VERSION whenever the wording changes, in step with
// QUOTE_TERMS_VERSION in serverless/100-api/common/slots.py (and its copy in
// 110-public-api/functions/public/slots.py). Acceptances are stored per version,
// so a new version asks the company to accept again, and until it does no quote
// can be sent and instant widget quotes stop (widgets fall back to callbacks).
//
// DRAFT: to be reviewed by a solicitor before production.

export const QUOTE_TERMS_VERSION = "2026-09-28";

export const QUOTE_TERMS_TITLE = "Quote terms: your prices are what your customers see";

export const QUOTE_TERMS: { heading: string; body: string }[] = [
  {
    heading: "Quotes use your prices, exactly as you set them",
    body:
      "Every quote is built from your catalogue (your cost prices), your packages, your pricing models (costs, markups and margins), your extras and your settings. Whatever you enter is what your customers are shown and can accept. We don't check, adjust or round your prices beyond the rounding you choose.",
  },
  {
    heading: "Check your prices before you switch quotes on, and keep them current",
    body:
      "The starter catalogue's prices are examples from public merchant websites on the date shown against each product. They are not your prices and will go out of date. Before you send a quote or switch on instant quotes, check every product, package, cost line, markup, extra, VAT rate, tariff and finance figure you use, and keep them up to date.",
  },
  {
    heading: "Instant quotes go to your customers without you seeing them first",
    body:
      "If you switch on detailed quotes for a website component, a customer who asks for one on your website is sent a quote straight away, built automatically from their home's energy certificate, their answers and your packages. You are responsible for every quote sent in your name, whether you sent it or it was sent automatically.",
  },
  {
    heading: "Quotes are subject to survey",
    body:
      "The heat loss behind a quote is an estimate from the published RdSAP method applied to the home's EPC (or your own survey figure, when you enter one). A quote is marked as subject to a home survey until you enter your survey heat loss. You must survey the home (as MCS requires) before installing, and if the survey changes what's needed, give the customer a revised quote before they commit.",
  },
  {
    heading: "Your offer, your contract",
    body:
      "A quote is your offer to your customer; xenquote is not a party to it. When a customer accepts online we record their typed name, the option and extras they chose, the time, their IP address and browser, and the version of your terms and conditions they accepted, and we tell you. The contract, the survey, deposits, finance and the installation are between you and your customer. Running costs, savings and grant amounts are estimates, shown with how they were worked out.",
  },
  {
    heading: "Finance",
    body:
      "Only switch on the finance example if you are authorised by the Financial Conduct Authority to broker credit (or are an appointed representative of a firm that is), and only with figures your lender has confirmed.",
  },
  {
    heading: "Customer data",
    body:
      "Quotes hold your customer's name, email address and phone number. You are the controller of that data and xenquote processes it for you under our data processing terms. You can delete a quote at any time.",
  },
];
